import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('admin_token') || '',
    user: JSON.parse(localStorage.getItem('admin_user') || '{}'),
    permissions: JSON.parse(localStorage.getItem('admin_permissions') || '[]'),
    sidebarCollapsed: false,
    systemConfig: JSON.parse(localStorage.getItem('system_config') || '{}')
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('admin_token', token)
    },
    SET_USER(state, user) {
      state.user = user
      localStorage.setItem('admin_user', JSON.stringify(user))
    },
    SET_PERMISSIONS(state, permissions) {
      state.permissions = permissions
      localStorage.setItem('admin_permissions', JSON.stringify(permissions))
    },
    SET_SYSTEM_CONFIG(state, config) {
      state.systemConfig = config
      localStorage.setItem('system_config', JSON.stringify(config))
    },
    TOGGLE_SIDEBAR(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed
    },
    CLEAR_AUTH(state) {
      state.token = ''
      state.user = {}
      state.permissions = []
      state.systemConfig = {}
      localStorage.removeItem('admin_token')
      localStorage.removeItem('admin_user')
      localStorage.removeItem('admin_permissions')
      localStorage.removeItem('system_config')
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    userInfo: state => state.user,
    permissions: state => state.permissions,
    hasPermission: state => perm => state.permissions.includes(perm),
    systemConfig: state => state.systemConfig
  }
})
